import * as Yup from 'yup';

export const FileYupSchema = Yup.object().shape({
  id: Yup.string(),
  file: Yup.string().nullable().required(),
  url: Yup.string().nullable().strip(true),
});

export const FilesYupSchema = Yup.array().of(FileYupSchema.required());
